// i18next bootstrap (Unit 36c, spec §11.11).
//
// Loaded once at module-import time. The initial language is hydrated from
// the settings endpoint by `AuthGuard` (which runs before the first paint of
// any real UI), but a sensible default of "en" is set here so the splash /
// login screen never renders untranslated keys.
//
// Out of scope: server-produced strings (LanguageTool messages, Anthropic
// content notes, score-report PDF body text). Those stay in the project
// language per spec §11.11.

import i18next, { type i18n as I18Next } from "i18next";
import { initReactI18next } from "react-i18next";

import en from "../locales/en.json";
import de from "../locales/de.json";

let initialised = false;

export function initI18n(initial: "en" | "de" = "en"): I18Next {
  if (!initialised) {
    void i18next.use(initReactI18next).init({
      lng: initial,
      fallbackLng: "en",
      resources: {
        en: { translation: en },
        de: { translation: de },
      },
      interpolation: { escapeValue: false },
      missingKeyHandler: (lngs, _ns, key) => {
        if (import.meta.env.DEV) {
          // eslint-disable-next-line no-console
          console.warn(`[i18n] missing key '${key}' for ${lngs.join(",")}`);
        }
      },
      // The two languages are the entire roster — saveMissing is unnecessary
      // and would touch the network.
      saveMissing: false,
      returnNull: false,
    });
    initialised = true;
  } else if (i18next.language !== initial) {
    void i18next.changeLanguage(initial);
  }
  return i18next;
}

export function changeLanguage(language: "en" | "de"): Promise<unknown> {
  return i18next.changeLanguage(language);
}

export { i18next };
